<template>
  <vk-modal-body>
    <services-modal-header>
      Submitting your request to Hand-Selected Local Professionals.
    </services-modal-header>
    <services-modal-body>
      <loading-indicator :size="48" />
    </services-modal-body>
  </vk-modal-body>
</template>
<script>
import ServicesModalHeader from './components/ServicesModalHeader';
import ServicesModalBody from './components/ServicesModalBody';

export default {
  name: 'spinner-modal',
  components: {
    ServicesModalHeader,
    ServicesModalBody,
  },
};
</script>
